<template>
  <div class="mobile-subscription">
    <Subscribe :hasTitle="false" />
  </div>
</template>

<script>
import Subscribe from '~/components/subscribe'

export default {
  components: {
    Subscribe
  }
}
</script>

<style lang="scss" scoped>
  .mobile-subscription {
    margin-top: $space-060;
    margin-left: $space-060;
    margin-right: $space-060;
    padding: 0;
  }
</style>
